export default "__VITE_ASSET__27xWXKXc__"